var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mx-auto",attrs:{"text":"","type":_vm.type,"icon":_vm.icons[_vm.type],"max-width":_vm.maxWidth}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }